// src/pages/admin/Projects.jsx
import React from 'react';
import AdminSidebar from '../../components/admin/AdminSidebar';
import ProjectManager from '../../components/admin/ProjectManager';

const Projects = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <AdminSidebar />
      <div className="flex-1 p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Manage Projects</h1>
          <p className="text-gray-600">Add and showcase completed projects</p>
        </div>
        <ProjectManager />
      </div>
    </div>
  );
};

export default Projects;